/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateTicketSubscriberRequest } from '../models/create-ticket-subscriber-request';
import { GenericResponse } from '../models/generic-response';
import { GetTicketSubscriberResponse } from '../models/get-ticket-subscriber-response';
import { SubscriberRequest } from '../models/subscriber-request';

/**
 * ticket subscriber api
 */
@Injectable({ providedIn: 'root' })
export class TicketSubscriberService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllTicketSubscribers()` */
  static readonly GetAllTicketSubscribersPath = '/api/v1/ticket-subscribers';

  /**
   * Get list of ticket subscribers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTicketSubscribers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTicketSubscribers$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetTicketSubscriberResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      TicketSubscriberService.GetAllTicketSubscribersPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetTicketSubscriberResponse>;
        })
      );
  }

  /**
   * Get list of ticket subscribers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTicketSubscribers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTicketSubscribers(
    params?: {},
    context?: HttpContext
  ): Observable<GetTicketSubscriberResponse> {
    return this.getAllTicketSubscribers$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetTicketSubscriberResponse>
        ): GetTicketSubscriberResponse => r.body
      )
    );
  }

  /** Path part for operation `addTicketSubscribers()` */
  static readonly AddTicketSubscribersPath = '/api/v1/ticket-subscribers';

  /**
   * Add subscribers to a ticket.
   *
   * Add  subscribers to a specific ticket.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addTicketSubscribers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTicketSubscribers$Response(
    params: {
      body: CreateTicketSubscriberRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      TicketSubscriberService.AddTicketSubscribersPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Add subscribers to a ticket.
   *
   * Add  subscribers to a specific ticket.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addTicketSubscribers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTicketSubscribers(
    params: {
      body: CreateTicketSubscriberRequest;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.addTicketSubscribers$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `deleteTicketSubscriber()` */
  static readonly DeleteTicketSubscriberPath =
    '/api/v1/ticket-subscribers/{id}';

  /**
   * Delete ticket subscriber by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTicketSubscriber()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTicketSubscriber$Response(
    params: {
      /**
       * The ticket subscriber id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      TicketSubscriberService.DeleteTicketSubscriberPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete ticket subscriber by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTicketSubscriber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTicketSubscriber(
    params: {
      /**
       * The ticket subscriber id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteTicketSubscriber$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateTicketSubscriber()` */
  static readonly UpdateTicketSubscriberPath =
    '/api/v1/ticket-subscribers/{id}';

  /**
   * Update ticket subscriber by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTicketSubscriber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTicketSubscriber$Response(
    params: {
      /**
       * The ticket subscriber's id that needs to be updated
       */
      id: number;
      body: SubscriberRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      TicketSubscriberService.UpdateTicketSubscriberPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Update ticket subscriber by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTicketSubscriber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTicketSubscriber(
    params: {
      /**
       * The ticket subscriber's id that needs to be updated
       */
      id: number;
      body: SubscriberRequest;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.updateTicketSubscriber$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }
}
